<template>
  <BasicLayout>
    <template #wrapper>
      <el-card style="margin-bottom: 12px;">
        <el-form :inline="true">
          <el-form-item label="选择活动">
            <el-select
              v-model="selectedActId"
              clearable
              style="width: 380px;"
              placeholder="请选择活动"
              filterable
              @change="handleActChange"
              @visible-change="handleVisibleChange"
            >
              <el-option
                v-for="item in actArr"
                :key="item.value"
                :label="getActOptionLabel(item)"
                :value="item.value"
              />
              <el-option
                v-if="hasMoreAct"
                value=""
                disabled
                style="text-align: center; cursor: pointer;"
              >
                <span v-if="actLoading" style="color: #999;">加载中...</span>
                <span v-else style="color: #409EFF;" @click.stop="loadMoreAct">点击加载更多</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini" @click="handleQuery(false)">查询</el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <firstCardGroupStat v-if="actLoaded" ref="firstCardGroupStat" :act-arr="actArr" :date-range="dateRange" :act-name-map="actNameMap" :selected-act-id="selectedActId" :has-more-act="hasMoreAct" />
      <CardGroupStat v-if="actLoaded" ref="cardGroupStat" :act-arr="actArr" :date-range="dateRange" :act-name-map="actNameMap" :selected-act-id="selectedActId" :has-more-act="hasMoreAct" />
      <CardInfo v-if="actLoaded" ref="cardInfo" :act-arr="actArr" :date-range="dateRange" :act-name-map="actNameMap" :selected-act-id="selectedActId" :has-more-act="hasMoreAct" />
    </template>
  </BasicLayout>
</template>
<script>
import firstCardGroupStat from '@/views/config/card-stat/components/firstCardGroupStat.vue'
import CardGroupStat from '@/views/config/card-stat/components/cardGroupStat.vue'
import CardInfo from '@/views/config/card-stat/components/cardDataStat.vue'
import { getActivtyList } from '@/api/config/activity-cfg'

export default {
  components: {
    firstCardGroupStat,
    CardGroupStat,
    CardInfo
  },
  data() {
    return {
      dateRange: {},
      actArr: [],
      actNameMap: {},
      selectedActId: '',
      loading: false,
      actPageIndex: 1,
      actPageSize: 10,
      actTotal: 0,
      actLoading: false,
      hasMoreAct: false,
      actLoaded: false
    }
  },
  watch: {
    actArr: {
      handler() {
        this.hasMoreAct = this.actArr.length < this.actTotal
      },
      deep: true
    }
  },
  created() {
    this.getCardAct()
  },
  methods: {
    getActOptionLabel(item) {
      const actName = this.actNameMap[item.value] || ''
      const dateRange = this.dateRange[item.value] || item.label
      return actName ? `${actName} - ${dateRange}` : dateRange
    },
    handleActChange(actId) {
      this.$refs.firstCardGroupStat && this.$refs.firstCardGroupStat.syncActChange(actId)
      this.$refs.cardGroupStat && this.$refs.cardGroupStat.syncActChange(actId)
      this.$refs.cardInfo && this.$refs.cardInfo.syncActChange(actId)
    },
    handleQuery() {
      if (!this.actLoaded) return
      if (this.selectedActId === '') {
        this.msgError('请选择活动')
        return
      }

      this.loading = true
      this.$refs.firstCardGroupStat && this.$refs.firstCardGroupStat.getTables()
      this.$refs.cardGroupStat && this.$refs.cardGroupStat.getTables()
      this.$refs.cardInfo && this.$refs.cardInfo.getTables()
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    getCardAct() {
      this.dateRange = {}
      this.actNameMap = {}
      this.actPageIndex = 0
      this.actArr = []
      const params = { type: 'time_limited_card' }
      getActivtyList(params).then(res => {
        this.actTotal = res.data.count || 0
        this.processActList(res.data.list || [])
        this.hasMoreAct = this.actArr.length < this.actTotal
        this.actLoaded = true
      })
    },
    processActList(list) {
      list.forEach(item => {
        if (this.actArr.some(act => act.value === item.id)) return
        const dateRange = item.start_time + '至' + item.end_time
        this.actArr.push({ label: dateRange, value: item.id })
        this.dateRange[item.id] = dateRange
        this.actNameMap[item.id] = `${item.imgNameStr}(${item.id})`
      })
    },
    handleVisibleChange(visible) {
      if (visible) {
        if (this.actArr.length > 0 && !this.selectedActId) {
          this.selectedActId = this.actArr[0].value
          this.handleActChange(this.selectedActId)
        }
        if (this.hasMoreAct && !this.actLoading) {
          this.loadMoreAct()
        }
      }
    },
    loadMoreAct() {
      if (this.actLoading) return
      this.actLoading = true
      this.actPageIndex++
      const params = { type: 'time_limited_card', pageIndex: this.actPageIndex, pageSize: this.actPageSize }
      getActivtyList(params).then(res => {
        this.actLoading = false
        this.processActList(res.data.list || [])
        if (this.actArr.length >= this.actTotal) {
          this.hasMoreAct = false
        }
      }).catch(() => {
        this.actLoading = false
      })
    }
  }
}
</script>
<style scoped>

</style>
